import { render, staticRenderFns } from "./buyFullversion.vue?vue&type=template&id=1ca5c318&scoped=true"
import script from "./buyFullversion.vue?vue&type=script&lang=js"
export * from "./buyFullversion.vue?vue&type=script&lang=js"
import style0 from "./buyFullversion.vue?vue&type=style&index=0&id=1ca5c318&prod&scoped=true&lang=css"
import style1 from "./buyFullversion.vue?vue&type=style&index=1&id=1ca5c318&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5c318",
  null
  
)

export default component.exports